import { hasS3Object } from "@/lib/aws-amplify/storage";

import { convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour } from "@/components/features/_shared/validation-schema/converter";

import { DUMMY_IMAGE } from "@/constants/dummy-image";

import type { ProductOptionFormModel } from "../../../../../type";
import type { ServerModel } from "../../type";


export const serverModelToInputModelConverter = (serverModel: ServerModel): ProductOptionFormModel["InputModel"] => {
	const { option, hotelPolicy } = serverModel;

	// 他のアイテムが初期値になりうるプロパティ
	const requiredPrepMillisecond: number = option.requiredPrepMillisecond || hotelPolicy?.requiredPrepMillisecond || 0;
	const cancelPolicy = option?.cancelPolicy ?? [];

	const { requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } =
		convertRequiredPrepMillisecondIntoRequiredPrepMillisecondBeforeDateAndHour(requiredPrepMillisecond);

	const inputModel: ProductOptionFormModel["InputModel"] = {
		hotelID: option.hotelID,
		optionID: option.optionID,

		name: option.name,

		optionType: option.optionType,

		availablePlanIDs: option.availablePlanIDs,

		billingTypeTarget: option.billingTypeTarget,
		billingTypeTerm: option.billingTypeTerm,
		description: option.description,
		inSale: option.inSale,
		isNextMorning: option.isNextMorning,
		isNotDiscountTarget: option.isNotDiscountTarget ?? false,
		keyVisuals: option.keyVisuals,
		/**
		 * 旧版で作成される場合、ダミー画像が設定されない
		 */
		mainKeyVisual: hasS3Object(option.mainKeyVisual) ? option.mainKeyVisual : DUMMY_IMAGE.s3Object,

		maxBuyableNumPerTarget: option.maxBuyableNumPerTarget ?? 0,
		maxDailyStockNum: option.maxDailyStockNum ?? undefined,
		maxStockNum: option.maxStockNum,
		minimumBuyableNumPerTarget: option.minimumBuyableNumPerTarget ?? undefined,

		price: option.price,

		saleEnd: option.saleEnd,
		saleStart: option.saleStart,
		saleStartBeforeDate: option.saleStartBeforeDate,
		saleTypeForPlan: option.saleTypeForPlan,
		saleTypeForTerm: option.saleTypeForTerm,

		stayableDayOfTheWeek: option.stayableDayOfTheWeek,
		isHolidayStayable: option.isHolidayStayable,
		stayableEnd: option.stayableEnd,
		stayableStart: option.stayableStart,

		subOptions: option.subOptions,
		useAsSubOption: option.useAsSubOption,
		multiSubOptionSelectable: option.multiSubOptionSelectable,
		isDateTabbedTimeSelectionEnabled: option.isDateTabbedTimeSelectionEnabled,

		// 他のアイテムが初期値になりうるプロパティ
		requiredPrepMillisecond,
		cancelPolicy,

		// InputModel 固有のプロパティ
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
	} satisfies ProductOptionFormModel["InputModel"];
	return inputModel;
};
